$(document).ready(function () {
    (function ($) {

        // Add owl carousel in cart page
        $('.owl-carousel').owlCarousel({
          animateOut: 'fadeOut',
          autoplaySpeed: 1200,
          loop: true,
          mouseDrag: true,
          touchDrag: true,
          items: 1.2,
          dots: false,
          autoplay: true,
          margin: 10,
          stagePadding: 0,
          autoplay: false
        });


        // Apply coupon code on click coupon in cart page
        $('.c-cart__container').on('click', '.c-coupon__item', function(event){
          event.preventDefault();
          var code = $(this).attr("data-code");
          if (code) {
            window.discountOnCartProApp.applyCode(code)
          }
        })
      

      
    })(jQuery);
});